// This is just an example,
// so you can safely delete all default props below

export default {
    previous_step: 'Back',
    next_step: 'Next Step',
    outward_trips: 'Outward trip',
    backward_trips: 'Backward trip',
    go_home: 'Go to start page',
    payment_option_desc: 'Choice of payment- / reservation product is selected on next page',
    error_outward_trip: 'Outward trip must be selected',
    error_backward_trip: 'Backward trip must be selected',
    error_trips_relation: 'NB! The backward trip must start after the outward trip.',
    time_passed_title:'The order time has now passed',
    time_passed_content:'The possibility to book this trip has been stopped because the booking time has passed for one of the choices. Select OK to return to the main page for a new travel search.',
    general_error_title: 'Roundtrip not supported on selected journey',
    general_error_content: 'It is not possible to buy this journey as one continuous round trip / ticket for a technical reasons. But you can buy this journey as two separate single trips / tickets.'
}
